import { Divider, Label, Table } from 'semantic-ui-react'
import { DateTime } from 'luxon'

import CalculationTableLink from './CalculationTableLink'
import { useReselector } from '@/utils/sharedHooks'
import {
  selectStatusInfoForCalculation,
  selectUserTaxCalculationById,
} from '@/selectors/userTaxCalculation.selectors'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { Text } from '@/componentsV1/BaseComponents'
import { UserTaxCalculationUser } from '../userTaxCalculation.slice'

const UserRecordDetails = ({ user }: { user: UserTaxCalculationUser }) => {
  const membership =
    user.memberships.find((record) => record.status === 'trial') ??
    user.memberships[0]

  const membershipInfo = () => {
    if (membership?.status === 'trial') {
      return (
        <p>
          <b>trial start date: </b>
          {DateTime.fromISO(membership.trialStartDate ?? '').toFormat(
            DATE_FORMATS_LUXON.DISPLAY_TIMEZONE
          )}
          <br />
          <b>trial end date: </b>
          {DateTime.fromISO(membership.trialEndDate ?? '').toFormat(
            DATE_FORMATS_LUXON.DISPLAY_TIMEZONE
          )}
        </p>
      )
    }
    return (
      <p>
        <b>membership start date: </b>
        {DateTime.fromISO(membership?.startDate ?? '').toFormat(
          DATE_FORMATS_LUXON.DISPLAY_TIMEZONE
        )}
      </p>
    )
  }
  return (
    <p>
      <b>created at: </b>
      {DateTime.fromISO(user.createdAt).toFormat(
        DATE_FORMATS_LUXON.DISPLAY_TIMEZONE
      )}
      <br />
      <b>membership status: </b>
      {user.memberships?.map((m) => m.status).join(', ')}
      <br />
      {membershipInfo()}
    </p>
  )
}

const CustomerTableCell = ({
  id,
  user,
}: {
  id: number
  user: UserTaxCalculationUser
}) => {
  const calc = useReselector(selectUserTaxCalculationById, id)
  const { color, text } = useReselector(selectStatusInfoForCalculation, id)

  if (!calc) {
    return null
  }

  const { firstName, lastName, userId } = calc
  return (
    <Table.Cell verticalAlign="top">
      <Text as="bodyMd">
        <b>
          {firstName} {lastName}
        </b>
      </Text>
      <Label style={{ borderRadius: '13px' }} color={color}>
        {text}
      </Label>
      <Divider />
      <UserRecordDetails user={user} />

      <CalculationTableLink
        url={`/admin/finances/financial-reports/${userId}/profit-loss`}
        text="Profit & Loss"
      />
      <CalculationTableLink
        url={`/admin/finances/records/${userId}`}
        text={`Profile (id: ${userId})`}
      />
    </Table.Cell>
  )
}

export default CustomerTableCell
